export interface EsimPlan {
  readonly id: string
  readonly size: string
  readonly days: string
  readonly price: string
  readonly priceMajor: number
  readonly body: string
  readonly featured: boolean
}

export const ESIM_PLANS: readonly EsimPlan[] = [
  { id: '1gb', size: '1 GB', days: '7 days', price: '$4.50', priceMajor: 4.5, body: 'Maps and messages for a short trip', featured: false },
  { id: '5gb', size: '5 GB', days: '30 days', price: '$14.00', priceMajor: 14, body: 'Enough for maps, WhatsApp and a few calls a day', featured: true },
  { id: '10gb', size: '10 GB', days: '30 days', price: '$22.00', priceMajor: 22, body: 'For a long stay, or sharing with family', featured: false },
]

export const ESIM_DESTINATIONS = [
  'Mexico · Telcel',
  'Colombia · Claro',
  'Brazil · Vivo',
  'Bolivia · Entel',
  'United States · AT&T',
] as const
